var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLicensePlate = function SvgIconLicensePlate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3E47DD",
    fillRule: "evenodd",
    d: "M4.5 5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3h-15Zm-1 3a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-15a1 1 0 0 1-1-1V8Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E47DD",
    d: "M7.63 15H6.51v-4.4l-1.35.43v-.89L7.5 9.3h.12V15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E47DD",
    fillRule: "evenodd",
    d: "M14.45 15H13.2l-.4-1.2h-2.04l-.4 1.2H9.13l2.11-5.69h1.1L14.44 15Zm-3.39-2.12h1.44l-.72-2.19-.72 2.2Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E47DD",
    d: "M17.6 15h-1.12v-4.4l-1.36.43v-.89l2.36-.84h.12V15Z"
  })));
};
export default SvgIconLicensePlate;